module.exports = __webpack_public_path__ + "img/floor_OG5.08447aaa.svg";